import jQuery from 'jquery';
import debounce from 'lodash/debounce';

let $ = jQuery;

const onViewChange = cb => {
  ['resize', 'orientationchange'].forEach(event => {
    window.addEventListener(event, debounce(cb, 100, { trailing: true }));
  });
}

const allToTallest = (sel, bp = 200) => {
  let nodes = !Array.isArray(sel) ? [...document.querySelectorAll(sel)] : sel;
  if (!nodes.length) return;
  nodes.forEach(el => el.style.height = 'auto')
  if (document.documentElement.clientWidth < bp) return;
  let nodeHeights = nodes.map(el => parseInt(el.offsetHeight))
  let tallest = Math.max(...nodeHeights)
  nodes.forEach(el => el.style.height = tallest + 'px')
}

const allToShortest = (sel, bp = 200) => {
  let nodes = !Array.isArray(sel) ? [...document.querySelectorAll(sel)] : sel;
  if (!nodes.length) return;
  nodes.forEach(el => el.style.height = 'auto')
  if (document.documentElement.clientWidth < bp) return;
  setTimeout(() => {
    let nodeHeights = nodes.map(el => parseInt(el.offsetHeight))
    let shortest = Math.min(...nodeHeights)
    nodes.forEach(el => el.style.height = shortest + 'px')
  }, 40)

}

const allToWidest = (sel) => {
  let nodes = !Array.isArray(sel) ? [...document.querySelectorAll(sel)] : sel;
  if (!nodes.length) return;
  nodes.forEach(el => el.style.width = 'auto')
  let nodeWidth = nodes.map(el => parseInt(el.offsetWidth))
  let widest = Math.max(...nodeWidth)
  nodes.forEach(el => el.style.width = widest + 5 + 'px')
}

const jQueryScrollTo = () => {
  $.fn.scrollTo = function (offset, speed) {
    if (typeof (speed) === 'undefined')
      speed = 1000;
    var offsetVal = offset || 0;
    $('html, body').animate({
      scrollTop: parseInt($(this).offset().top + offsetVal)
    }, speed);
  };
}

const getMaxY = (nodes) => {
  if (!Array.isArray(nodes) || !nodes.length) return;
  nodes.forEach(el => el.style.height = 'auto')
  const nodeHeights = nodes.map(el => parseInt(el.offsetHeight))
  return Math.max(...nodeHeights)
}

const queryAll = (sel) => [...document.querySelectorAll(sel)];

const pauseFor = (ms) => {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

function delay(fn, ms) {
  let timer = 0
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(fn.bind(this, ...args), ms || 0)
  }
}

const echoIf = (predicate, output) => predicate ? output : '';

const calcScrollTo = (element) => {
  const $target = $(element);
  if (!$target.length) return;
  const dampen = $target.data('scroll-dampen') || 0;
  const headerHeight = 159; // hardcoded header height + buffer
  const adminBarHeight = $('#wpadminbar').height() || 0;
  const targetScrollTo = $target.offset().top - (headerHeight + adminBarHeight + parseInt(dampen));
  return targetScrollTo > 0 ? targetScrollTo : 0;
}

export {
  calcScrollTo,
  jQueryScrollTo,
  allToTallest,
  allToShortest,
  onViewChange,
  queryAll,
  echoIf,
  allToWidest,
  delay,
}
